<!--autosize-->
<mat-drawer-container class="forms-list"
                      (dragover)="this.blockDrop($event)"
                      (drop)="this.blockDrop($event)">
    <mat-drawer-content id="mat-drawer-content">
        <app-list-view class="form-list-container"
                       [list]="this.ListItems"
                       [title]="'Form Template Catalog'"
                       [heading]="'Form Template Catalog'"
                       [buttonConfig]="this.ButtonConfig"
                       [columnsConfig]="this.ColumnsConfig"
                       [typeSortOrderConfig]="this.TypeSortOrderConfig"
                       (editClick)="doOnEdit($event)"
                       (itemActionClick)="doOnItemAction($event)"
                       (buttonClick)="doOnButtonClick($event)"
                       (itemDeleted)="doOnItemDelete($event)"
                       (itemContextMenu)="doOnItemContextMenu($event)"
                       (filesDropped)="this.onFileDropped($event)">
        </app-list-view>

        <!-- 04-15-2021:  added the following context menu and menu trigger. -->

        <app-context-menu #itemContextMenuComponent
                          [contextMenuData]="this.ItemContextMenuData"
                          [menuName]="'itemContextMenuComponent'"
                          style="visibility: hidden; position: fixed"></app-context-menu>


        <div (drop)="onFileDroppedFillRemaining($event)"
             (dragover)="allowDrop($event)"
             class="fill-remaining">
        </div>

    </mat-drawer-content>

    <!--
         mode="side"
         position="start"
    -->
    <mat-drawer #drawer
                mode="over"
                position="end"
                [opened]="this.ShowEditPropertiesDrawer"
                (closedStart)="this.drawerClosing()">
        <!-- Drawer header content. -->
        <mat-toolbar>
            <span>{{this.DetailsDrawerTitle}}</span>
            <span class="info-drawer-toolbar-spacer"></span>
            <button mat-icon-button (click)="this.closeDrawerClicked()" tabindex="-1"><mat-icon>close</mat-icon></button>
        </mat-toolbar>
        <div id="details-drawer-keyboard-focus-div" tabindex="-1"></div>

        <!-- Drawer body content. -->
        <app-form-details *ngIf="this.ShowEditPropertiesDrawer"
                          [form]="this.SelectedForm"
                          [mode]="this.EditFormPropertiesMode"
                          (save)="this.doOnFormSave($event)"
                          (close)="this.doOnFormPropertiesClose($event)"></app-form-details>
    </mat-drawer>
</mat-drawer-container>
